import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from '../util';
const Small = (_jsx("svg", Object.assign({ width: "12", height: "24", viewBox: "0 0 12 24" }, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 4H9v1h2v4H9v1h2v4H9v1h2v4H9v1h2v2c0 .551-.448 1-1 1H2c-.552 0-1-.449-1-1v-2h2v-1H1v-4h2v-1H1v-4h2V9H1V5h2V4H1V2c0-.551.448-1 1-1h8c.552 0 1 .449 1 1v2zm-1-4H2C.896 0 0 .896 0 2v20c0 1.104.896 2 2 2h8c1.104 0 2-.896 2-2V2c0-1.104-.896-2-2-2z" }, void 0) }), void 0));
export const variants = {
    small: Small,
    default: Small,
};
export default withVariants(variants);
